import React, { useState, useRef, useEffect } from 'react'


const CountdownTimer = ({ 
    count = 10, 
    reset = false, 
    onComplete = () => false, 
    onReset = () => false,
	updatedOuterTimer
}) => {

	const Ref = useRef(null);
	// The state for our timer
	const [timer, setTimer] = useState('00:00');


	const getTimeRemaining = (e) => {
		const total = Date.parse(e) - Date.parse(new Date());
		const seconds = Math.floor((total / 1000) % 60);
		const minutes = Math.floor((total / 1000 / 60) % 60);
		const hours = Math.floor((total / 1000 * 60 * 60) % 24);
		return {
			total, hours, minutes, seconds
		};
	}


	const startTimer = (e) => {
		let { total, hours, minutes, seconds } = getTimeRemaining(e);
		if (total >= 0) {

			// update the timer
			// check if less than 10 then we need to
			// add '0' at the begining of the variable
			setTimer(
				//(hours > 9 ? hours : '0' + hours) + ':' +
				(minutes > 9 ? minutes : '0' + minutes) + ':'
				+ (seconds > 9 ? seconds : '0' + seconds)
			);
			updatedOuterTimer(
				(minutes > 9 ? minutes : '0' + minutes) + ':'
				+ (seconds > 9 ? seconds : '0' + seconds)
			)
		}
	}


	const clearTimer = (e) => {

		// If you adjust it you should also need to adjust the Endtime formula we are about to code next	
		setTimer('01:00');

		// If you try to remove this line the
		// updating of timer Variable will be
		// after 1000ms or 1sec
		if (Ref.current) clearInterval(Ref.current);
		const id = setInterval(() => {
			startTimer(e);
		}, 1000)
		Ref.current = id;
	}

	const getDeadTime = () => {
		let deadline = new Date();

		// This is where you need to adjust if you entend to add more time
		deadline.setSeconds(deadline.getSeconds() + count);
		return deadline;
	}

	useEffect(() => clearTimer(getDeadTime()), [ count ]);

    //useEffect( () => clearTimer(getDeadTime()))

	return (
		<span className="p-2 numbers">{timer}</span>
	)
}

export default CountdownTimer;
